import type { JSX } from 'react';

import { ChevronLeftIcon, ChevronRightIcon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

type NavigationArrowsProps = {
	canScrollLeft: boolean;
	canScrollRight: boolean;
	onScrollLeft: () => void;
	onScrollRight: () => void;
};

export function NavigationArrows({
	canScrollLeft,
	canScrollRight,
	onScrollLeft,
	onScrollRight,
}: NavigationArrowsProps): JSX.Element {
	const baseClassName =
		'border-stroke-weaker absolute top-1/2 shadow-lg z-20 hidden h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-solid bg-white md:flex';
	return (
		<>
			{canScrollLeft && (
				<button
					aria-label="Scroll left"
					className={cn(baseClassName, 'left-0 -translate-x-1/2')}
					onClick={onScrollLeft}
					data-testid="carousel-scroll-left"
					data-qa="carousel-scroll-left"
					type="button"
				>
					<ChevronLeftIcon className="h-5 w-5" size={20} />
				</button>
			)}
			{canScrollRight && (
				<button
					aria-label="Scroll right"
					className={cn(baseClassName, 'right-0 translate-x-1/2')}
					onClick={onScrollRight}
					data-testid="carousel-scroll-right"
					data-qa="carousel-scroll-right"
					type="button"
				>
					<ChevronRightIcon className="h-5 w-5" size={20} />
				</button>
			)}
		</>
	);
}
